const FOCUSABLE = [
  'a[href]',
  'button:not([disabled])',
  'input:not([disabled])',
  'select:not([disabled])',
  'textarea:not([disabled])',
  '[tabindex]:not([tabindex="-1"])',
].join(',');

/** Tabbable elements inside `container`, in DOM order (skips hidden / `inert` subtrees). */
export function getFocusable(container: HTMLElement | null): HTMLElement[] {
  if (container == null) return [];
  return Array.from(container.querySelectorAll<HTMLElement>(FOCUSABLE)).filter(
    (el) => el.offsetParent !== null || el === document.activeElement,
  );
}

/** Move focus into `container`: the element flagged `data-autofocus`, else the first tabbable. */
export function focusInitial(container: HTMLElement | null): void {
  if (container == null) return;
  const preferred = container.querySelector<HTMLElement>('[data-autofocus]');
  const target = preferred ?? getFocusable(container)[0] ?? container;
  target.focus();
}

/** Keep Tab / Shift+Tab cycling within `container` by wrapping at the edges. */
export function wrapTabFocus(container: HTMLElement | null, event: KeyboardEvent): void {
  const focusable = getFocusable(container);
  if (focusable.length === 0) {
    event.preventDefault();
    return;
  }
  const first = focusable[0];
  const last = focusable[focusable.length - 1];
  const active = document.activeElement;
  if (event.shiftKey && active === first) {
    event.preventDefault();
    last?.focus();
  } else if (!event.shiftKey && active === last) {
    event.preventDefault();
    first?.focus();
  }
}
